import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../../Fields/TextInput";
import DatePicker from "../../Fields/DatePicker";
import EasyAccordian from "../EasyAccordian";
import CheckBox from "../../Fields/CheckBox";
import SelectBox from "../../Fields/SelectBox";
import AuthoritySearch from "../../../components/IpSequenceSearch/AuthoritySearch";
import Typography from '@material-ui/core/Typography';
import styles from "./SearchComponents.module.css"
import Tooltip from '@material-ui/core/Tooltip';
import _, { set } from "lodash";
import { getDocsUrl } from '../../../helpers/docsUrl';

const Databasefilters = (props) =>{

    const { t, i18n } = useTranslation('common');

    const {formJson, setFormJson} = props

    const GQSpecificSel = [
        {
            value: "LTE",
            label: "is less than or equal to",
            id: "LTE"
        },
        {
            value: "LT",
            label: "is less than",
            id: "LT"
        },
        {
            value: "EQ",
            label: "equals",
            id: "EQ"
        },
        {
            value: "NEQ",
            label: "does not equal",
            id: "NEQ"
        },
        {
            value: "GT",
            label: "is greater than",
            id: "GT"
        },
        {
            value: "GTE",
            label: "is greater than or equal to",
            id: "GTE"
        }
    ];
    
    const docPublicSel = [
        {
            value: "BEF",
            label: "Before",
            id: "BEF"
        },
        {
            value: "BEF_IE",
            label: "Before or is empty",
            id: "BEF_IE"
        },
        {
            value: "AFT",
            label: "After",
            id: "AFT"
        },
        {
            value: "AFT_IE",
            label: "After or is empty",
            id: "AFT_IE"
        }
    ];

    const sdbAtom = {
       SEQUENCE_D1:{
           active: false,
           P:"SEQUENCE_D1", 
           O: docPublicSel[0].value,
           V: Date.now()
       },
       SEQUENCE_D4:{
           active: false,
           P:"SEQUENCE_D4", 
           O: docPublicSel[0].value,
           V: Date.now()
       },
       SEQUENCE_PN:{
           active: false,
           P:"SEQUENCE_PN",
           O:"CT",
           V:""
       },
       SEQUENCE_D2:{
           active: false,
           P: "SEQUENCE_D2",
           O: docPublicSel[0].value,
           V: Date.now()
       },
       SEQUENCE_P9:{
           active: false,
           P: "SEQUENCE_P9",
           O:  GQSpecificSel[0].value,
           V: "100000"
       }
    };

    function yyyymmddToDate(str) {
        if (!str || str.length !== 8) return null;
        const year = parseInt(str.slice(0, 4), 10);
        const month = parseInt(str.slice(4, 6), 10) - 1; // JS months are 0-based
        const day = parseInt(str.slice(6, 8), 10);
        return new Date(year, month, day);
    }

    const [isRedo, setIsRedo] = useState(false);
    const [isPatentAuth, setIsPatentAuth] = useState(false);

    const validatePatentAuth = () => {
        const hasValue = !!formJson.searchInfo.sdb_filters.SEQUENCE_PN.V;
        if(formJson.searchInfo.sdb_filters.SEQUENCE_PN.active && !hasValue){
            if(!formJson.layout.errorIdList.includes("isPatentAuth")){
                formJson.layout.errorIdList.push("isPatentAuth");
            }
        }else{
            formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "isPatentAuth");
        }
    };

    useEffect(()=>{
        if(formJson){

            if(formJson.searchInfo){
                
                let change = false
                    if(formJson.searchInfo.seqlenrange_low === undefined){
                        formJson.searchInfo.seqlenrange_low = 6;
                        change = true;
                    }
                    if(formJson.searchInfo.seqlenrange_high === undefined){
                        formJson.searchInfo.seqlenrange_high = 100000;
                        change = true;
                    }
                    if(formJson.searchInfo.sdb_filters === undefined){
                        formJson.searchInfo.sdb_filters = _.cloneDeep(sdbAtom);

                        change = true;
                    }else{
                        let sdbArr = [];
                        let sdb_filters = formJson.searchInfo.sdb_filters;
                        // If sdb_filters is not empty, parse it back to array of objects
                        if (typeof sdb_filters === "string" && sdb_filters.length > 0) {
                            
                            // sbdString is a comma-separated string of [object Object]
                            // You should store sdb_filters as JSON.stringify([...]) in formatPostData for reliable reversal.
                            // If not, parsing will not work. If you do, use:
                            try {

                                setIsPatentAuth(true);
                                setIsRedo(true);

                                sdbArr = JSON.parse(sdb_filters);
                                let sdbObj = _.cloneDeep(sdbAtom); // start with defaults, all inactive
                                
                                for (let i = 0; i < sdbArr.length; i++) {
                                    if(sdbArr[i].P == "SEQUENCE_D1" || sdbArr[i].P == "SEQUENCE_D2" || sdbArr[i].P == "SEQUENCE_D4"){
                                        sdbObj[sdbArr[i].P] = {
                                            P: sdbArr[i].P,
                                            O: sdbArr[i].O,
                                            V: yyyymmddToDate(sdbArr[i].V),
                                            active: true
                                        };
                                    }else{
                                        sdbObj[sdbArr[i].P] = {
                                            P: sdbArr[i].P,
                                            O: sdbArr[i].O,
                                            V: sdbArr[i].V,
                                            active: true
                                        };
                                    }
                                }
                                formJson.searchInfo.sdb_filters = sdbObj;
                                change = true;
                                
                            } catch (e) {
                                console.log(sdb_filters)
                            }
                            
                        } 

                    }
                  
                    if(change){
                        setFormJson({...formJson})
                    }
                }
            }
        },[formJson])

   

    return(
        <div>
            {formJson.searchInfo.sdb_filters && typeof formJson.searchInfo.sdb_filters === "object" &&
            <div>
            <div>
                <a href={getDocsUrl('ip_sequence_searching.html', 'subjectdbselection')} target="_blank" className="appTextFont appLink float-right" rel="noreferrer">{t("help")}</a>
            </div>
            <div>
                <EasyAccordian
                    header = "General sequence database filters"
                    startOpen={false}
                >
                    <div style={{marginLeft: "20px"}}>
                            <div style={{display: "flex", alignItems: "center", paddingBottom: "10px"}}>
                                <span>
                                    {t("searchOnlySeqBetween")}
                                </span>
                                <span style={{display: "flex", alignItems: "center"}} className={styles.paddingLR10}>
                                    <Tooltip arrow title={formJson.layout.errorIdList.includes("seqlenrange_low") ? 'Minimum allowed value is 3. Must be less than Max': ""} placement="bottom">
                                    <TextInput 
                                        type="number"
                                        id="seqlenrange_low"
                                        fullWidth={false}
                                        variant="outlined"
                                        className={styles.width100}
                                        value={formJson.searchInfo.seqlenrange_low}
                                        onChange={(e)=>{                                            

                                            let val = e.currentTarget.value;

                                            //if its not a number add seqLenRange_low to errorIdList
                                            if(val < 3 || val === "" || parseInt(val) > parseInt(formJson.searchInfo.seqlenrange_high)){
                                                if(!formJson.layout.errorIdList.includes("seqlenrange_low")){
                                                    formJson.layout.errorIdList.push("seqlenrange_low");
                                                }
                                            }else{
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "seqlenrange_low");
                                            }

                                            formJson.searchInfo.seqlenrange_low = val;
                                            setFormJson({...formJson})
                                        }}
                                        error={formJson.layout.errorIdList.includes("seqlenrange_low")}
                                    />
                                    </Tooltip>
                                <span className={styles.paddingLR10}> to </span>
                                    <Tooltip arrow title={formJson.layout.errorIdList.includes("seqlenrange_high") ? 'Max should be more than Min': ""} placement="bottom">
                                    <TextInput
                                        type="number"
                                        id="seqlenrange_high"
                                        fullWidth={false}
                                        variant="outlined"
                                        className={styles.width100}
                                        value={formJson.searchInfo.seqlenrange_high}
                                         onChange={(e)=>{
                                            let val = e.currentTarget.value;

                                            //if not a number add seqLenRange_high to errorIdList
                                            if(val === "" || parseInt(val) < parseInt(formJson.searchInfo.seqlenrange_low)){
                                                if(!formJson.layout.errorIdList.includes("seqlenrange_high")){
                                                    formJson.layout.errorIdList.push("seqlenrange_high");
                                                }
                                            }else{
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "seqlenrange_high");
                                            }

                                            formJson.searchInfo.seqlenrange_high = val;
                                            setFormJson({...formJson})
                                        }}
                                        error={formJson.layout.errorIdList.includes("seqlenrange_high")}
                                    />
                                    </Tooltip>
                                </span>
                                <span>
                                    {t("residuesInLength")}
                                </span>
                            </div>
                            <div style={{width: "100%",display: 'flex', alignItems: "center", paddingBottom: "10px"}}>
                                <CheckBox
                                    color="primary"
                                    onChange={()=>{
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D1.active = !formJson.searchInfo.sdb_filters.SEQUENCE_D1.active
                                        setFormJson({...formJson})
                                    }}
                                    checked={formJson.searchInfo.sdb_filters.SEQUENCE_D1.active}
                                    id={"DocumentPublicationDate"}
                                />
                                <span style={{paddingRight: "20px"}} htmlFor="DocumentPublicationDate">{t("docPublicationDate")}</span>
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    id="docPublicSel"
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_D1.O}
                                    onChange={(e)=>{
                                        let test = e.target.value
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D1.O = test;
                                        setFormJson({...formJson})
                                    }}
                                    items={docPublicSel}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_D1.active}
                                />
                                <DatePicker
                                    name="docPublicDate"
                                    dateFormat="MMMM-d-yyyy"
                                    label="Date picker inline"
                                    inputVariant="outlined"
                                    style={{color: '#292929'}}
                                    onChange={ val => {
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D1.V = val;
                                        setFormJson({...formJson})
                                    }}
                                    className={"mb-2 ml-4 bodyText"}
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_D1.V}
                                    disablePast={false}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_D1.active}
                                />
                            </div>
                            
                            <div style={{ width: '100%', display: 'flex', alignItems: "center", paddingBottom: "5px" }}>
                                <CheckBox
                                    color="primary"
                                    className={""}
                                    id="isPatentAuth"
                                     onChange={()=>{
                                        formJson.searchInfo.sdb_filters.SEQUENCE_PN.active = !formJson.searchInfo.sdb_filters.SEQUENCE_PN.active
                                        validatePatentAuth();
                                        setFormJson({...formJson})
                                    }}
                                    checked={formJson.searchInfo.sdb_filters.SEQUENCE_PN.active}
                                />
                                <span style={{width: "252px"}}>{t("patentAuthorityOnly")}</span>
                                 <AuthoritySearch
                                    actionModal = {(value)=>{
                                        let test = value
                                        if(Array.isArray(test)){
                                            //add * after each entry
                                            test = test.map(item => item + "*");
                                        }else{
                                            test = test + "*";
                                        }
                                        const newV = test+"";
                                        formJson.searchInfo.sdb_filters.SEQUENCE_PN.V = newV;
                                        if(!newV){
                                            formJson.searchInfo.sdb_filters.SEQUENCE_PN.active = false;
                                        }
                                        validatePatentAuth();
                                        setFormJson({...formJson})
                                    }}
                                    isPatentAuth={formJson.searchInfo.sdb_filters.SEQUENCE_PN.active}
                                    redoPA = {isRedo}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_PN.active || formJson.layout.isRedo}
                                    itemV = {formJson.searchInfo.sdb_filters.SEQUENCE_PN.V}
                                    hasError = {formJson.layout.errorIdList.includes("isPatentAuth")}
                                />
                            </div>
                            {formJson.layout.errorIdList.includes("isPatentAuth") &&
                                <div style={{width: "100%", paddingBottom: "15px"}}>
                                    <span className={"ManualError"} id="isPatentAuthError">You must enter at least one valid patent authority</span>
                                </div>
                            }

                    </div>
                </EasyAccordian>
            </div>
            {(formJson.searchInfo.protdbs.includes("GQPAT_PRT_MS") || formJson.searchInfo.nucdbs.includes("GQPAT_NUC_MS")) ?
            <div>
                <EasyAccordian
                    header = "GQ-Pat specific Database Filters​"
                    startOpen={false}
                >
                        <div style={{marginLeft: "20px"}}>
                            <div style={{width: "100%",display: 'flex', alignItems: "center", paddingBottom: "10px"}}>

                                <CheckBox
                                    color="primary"
                                    id="publishGenomeQuest"
                                      onChange={()=>{
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D2.active = !formJson.searchInfo.sdb_filters.SEQUENCE_D2.active
                                        setFormJson({...formJson})
                                    }}
                                    checked={formJson.searchInfo.sdb_filters.SEQUENCE_D2.active}
                                />
                                <span style={{paddingRight: "36px"}} htmlFor="publishGenomeQuest">{t("publishedInGenomeQuest")}</span>
                            
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    id="publishGQSel"
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_D2.O}
                                    onChange={(e)=>{
                                        let test = e.target.value
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D2.O = test;
                                        setFormJson({...formJson})
                                    }}
                                    items={docPublicSel}
                                    className={""}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_D2.active}
                                />
                                <DatePicker
                                    margin="normal"
                                    id="publishGQDate"
                                    dateFormat="MMMM-d-yyyy"
                                    inputVariant="outlined"
                                    allowKeyboardControl={false}
                                    disablePast={false}
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_D2.V}
                                    onChange={ val => {
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D2.V =  val
                                        setFormJson({...formJson})
                                    }}
                                    className={"mb-2 ml-4 bodyText"}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_D2.active}
                                />
                            </div>
                            <div style={{width: "100%",display: 'flex', alignItems: "center", paddingBottom: "10px"}}>
                                <CheckBox
                                    color="primary"
                                    onChange={()=>{
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D4.active = !formJson.searchInfo.sdb_filters.SEQUENCE_D4.active
                                        setFormJson({...formJson})
                                    }}
                                    checked={formJson.searchInfo.sdb_filters.SEQUENCE_D4.active}
                                    id={"EarliestPriorityDate"}
                                />
                                <span style={{paddingRight: "20px"}} htmlFor="EarliestPriorityDate">{t("earliestPriorityDate")}</span>
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    id="earliestPrioritySel"
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_D4.O}
                                    onChange={(e)=>{
                                        let test = e.target.value
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D4.O = test;
                                        setFormJson({...formJson})
                                    }}
                                    items={docPublicSel}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_D4.active}
                                />
                                <DatePicker
                                    margin="normal"
                                    id="earliestPriorityDate"
                                    dateFormat="MMMM-d-yyyy"
                                    inputVariant="outlined"
                                    allowKeyboardControl={false}
                                    disablePast={false}
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_D4.V}
                                    onChange={ val => {
                                        formJson.searchInfo.sdb_filters.SEQUENCE_D4.V =  val
                                        setFormJson({...formJson})
                                    }}
                                    className={"mb-2 ml-4 bodyText"}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_D4.active}
                                />
                            </div>
                            <div style={{ width: "100%", display: 'flex', alignItems: "center"}}>
                                <CheckBox
                                    color="primary"
                                    id="isPatientDoc"
                                    onChange={()=>{
                                        formJson.searchInfo.sdb_filters.SEQUENCE_P9.active = !formJson.searchInfo.sdb_filters.SEQUENCE_P9.active
                                        setFormJson({...formJson})
                                    }}
                                    checked={formJson.searchInfo.sdb_filters.SEQUENCE_P9.active }
                                    className={""}
                                />
                                <span style={{paddingRight: "42px"}} htmlFor="isPatientDoc">{t("patentDocContains")}</span>
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="patientDocSel"
                                    id="patientDocSel"
                                    value={formJson.searchInfo.sdb_filters.SEQUENCE_P9.O}
                                    onChange={(e)=>{
                                        let test = e.target.value
                                        formJson.searchInfo.sdb_filters.SEQUENCE_P9.O = test
                                        setFormJson({...formJson})
                                    }}
                                    items={GQSpecificSel}
                                    className={""}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_P9.active}
                                />
                                <Tooltip arrow title={formJson.layout.errorIdList.includes("patientDocInp") ? 'Enter Value greater than 0': ""} placement="bottom">
                                    <TextInput
                                        type="number"
                                        id="patientDocInp"
                                        variant="outlined"
                                        value={formJson.searchInfo.sdb_filters.SEQUENCE_P9.V}
                                    onChange={(e)=>{
                                        let test = e.currentTarget.value
                                        if(isNaN(test) || test === "" || test < 0){
                                            if(!formJson.layout.errorIdList.includes("patientDocInp")){
                                                formJson.layout.errorIdList.push("patientDocInp")
                                            }
                                        }else{
                                            if(formJson.layout.errorIdList.includes("patientDocInp")){
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(item => item !== "patientDocInp")
                                            }
                                        }
                                        formJson.searchInfo.sdb_filters.SEQUENCE_P9.V = test
                                        setFormJson({...formJson})
                                    }}
                                    error={false}
                                    placeholder={0}
                                    className={"mb-2 ml-4 bodyText "+ styles.medTextBox}
                                    disabled={!formJson.searchInfo.sdb_filters.SEQUENCE_P9.active}
                                />
                                </Tooltip>
                                <Typography style={{paddingLeft: "10px"}}>
                                    {(t("sequences"))}
                                </Typography>
                            </div>

                        </div> 
                    
                </EasyAccordian>
            </div>
            :  
            <div>
            <Tooltip title={"Must Check GQ-Pat database to enable"} arrow placement="bottom">
            <div style={{width: "280px"}}>
            <EasyAccordian
                header = "GQ-Pat specific Database Filters​"
                startOpen={false}
                disabled={true}
            >
            </EasyAccordian>
            </div>
            </Tooltip>
            </div>
            }
            </div>      
            }                        
        </div>
    )
}

export default Databasefilters